export const CLASS_TRANSFORMER_GLOBAL_CONFIG = {
  // TODO: not possible at the moment, because class level @Exclude decorator is not inherited.
  // https://github.com/typestack/class-transformer/issues/1097
  // strategy:'exposeAll', 
  strategy: 'excludeAll',
  nestedStrategy: 'exposeAll',
  excludeExtraneousValues: true
};